import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { dialog, UrlDialogInfo, app } from "@microsoft/teams-js";
import { getBaseUrl } from '../../configVariables';
import { deleteTemplate } from '../../apis/messageListApi';
import { selectTemplate, getAllTemplatesList, getTemplateColorsList } from '../../actions';
import { TFunction } from "i18next";
import { Menu, MenuTrigger, MenuButton, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import { MoreHorizontal24Regular, Edit24Regular, Delete24Regular } from '@fluentui/react-icons';
import { initializeTeamsApp } from '../../helpers/teamsApp';

export interface OverflowProps extends WithTranslation {
    template?: any;
    styles?: object;
    resetPageCallback?: any;
    selectTemplate?: any;
    getAllTemplatesList?: any;
    getTemplateColorsList?: any;
    onSelectTemplate?: any;
}

export interface OverflowState {
    menuOpen: boolean;
    selectTemplate?: any;
}

class Overflow extends React.Component<OverflowProps, OverflowState> {
    readonly localize: TFunction;
    constructor(props: OverflowProps) {
        super(props);
        this.localize = this.props.t;
        this.state = {
            menuOpen: false,
        };
    }

    public async componentDidMount() {
        await initializeTeamsApp();
    }

    public render(): JSX.Element {
        return <Menu >
            <MenuTrigger disableButtonEnhancement>
                <MenuButton onClick={e => e.stopPropagation()} icon={< MoreHorizontal24Regular />} appearance='transparent' />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem key='edit' icon={<Edit24Regular />}>{this.localize("Edit")}</MenuItem>
                    {(this.props.template.isDynamic && this.props.template.id !== "010") && (
                        <MenuItem key='delete' icon={<Delete24Regular />} onClick={this.onDeleteClick}>{this.localize("Delete")}</MenuItem>
                    )}
                </MenuList>
            </MenuPopover>
        </Menu>
    }

    private onDeleteClick = (event: any) => {
        event.stopPropagation();
        let url = getBaseUrl() + "/deletetemplate/" + this.props.template.id + "?locale={locale}";
        this.onOpenTaskModule(null, url, this.localize("DeleteTemplate"));
    }

    private onOpenTaskModule = (event: any, url: string, title: string) => {
        let taskInfo: UrlDialogInfo = {
            url: url,
            title: title,
            size: {
                height: 660,
                width: 1000
            },
            fallbackUrl: url,
        };
        let submitHandler = (result: dialog.ISdkResponse) => {
            this.props.getAllTemplatesList();
        };
        dialog.url.open(taskInfo, submitHandler);
    }

    private deleteTemplate = async (id: string) => {
        try {
            await deleteTemplate(id);
            this.props.getAllTemplatesList().then(() => {
                this.props.getTemplateColorsList();
            })
        } catch (error) {
            return error;
        }
    }
}

const mapStateToProps = (state: any) => {
    return { selectTemplate: state.selectTemplate, templatesList: state.templatesList, templateColorsList: state.templateColorsList };
}

const overflowWithTranslation = withTranslation()(Overflow);
export default connect(mapStateToProps, { selectTemplate, getAllTemplatesList, getTemplateColorsList })(overflowWithTranslation);
